import { render, staticRenderFns } from "./staffProfile.vue?vue&type=template&id=2e8db7b0&scoped=true&"
import script from "./staffProfile.vue?vue&type=script&lang=js&"
export * from "./staffProfile.vue?vue&type=script&lang=js&"
import style0 from "./staffProfile.vue?vue&type=style&index=0&id=2e8db7b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8db7b0",
  null
  
)

export default component.exports